/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import {
  LogoWrapper,
  LogoImage,
  StaticWrapper,
  PageHeader,
  DividerLine,
  TableResponsive,
  Table,
  TableStriped,
  StaticContent,
  TabList,
  TabItem,
  ContentSection,
  SaarthiContentSection
} from "./Common";

export {
  LogoWrapper,
  LogoImage,
  StaticWrapper,
  PageHeader,
  DividerLine,
  TableResponsive,
  Table,
  TableStriped,
  StaticContent,
  TabList,
  TabItem,
  ContentSection,
  SaarthiContentSection
};
